// Routes & Breadcrumbs — the only content that should remain here.
// All types moved to src/types/Collateral.ts
// All formatters moved to src/utils/collateralFormatters.ts
// All color functions moved to src/utils/collateralFormatters.ts

export const COLLATERAL_ROUTES = {
    verificationConfig: '/collateral/verification-config',
    verificationConfigEdit: (id: number) => `/collateral/verification-config/${id}/edit`,
    verificationConfigView: (id: number) => `/collateral/verification-config/${id}/view`,
    draweeConfirmation: '/collateral/drawee-confirmation',
    draweeConfirmationEdit: (id: number) => `/collateral/drawee-confirmation/${id}/edit`,
    receivables: (confirmationId: number) => `/collateral/drawee-confirmation/${confirmationId}/receivables`,
} as const;

export const COLLATERAL_BREADCRUMBS = {
    structuring: { label: 'Estruturação', url: '/structuring' },
    collateral: { label: 'Garantia', url: COLLATERAL_ROUTES.verificationConfig },
    verificationConfig: { label: 'Verificação de Recebíveis', url: COLLATERAL_ROUTES.verificationConfig },
    draweeConfirmation: { label: 'Validação de Sacados', url: COLLATERAL_ROUTES.draweeConfirmation },
    receivables: { label: 'Recebíveis', url: '#' },
} as const;
